import register from '../../../../global/js/registry';
export default register('m-formstep-select-image', () => import(/* webpackMode: "lazy" */ './m-formstep-select-image.controller'));
